import DocumentTitle from 'react-document-title';
import { Route } from 'react-router';
import SMRDesktop, { HaynesProTypeEnum } from './smr/desktop';
import VehiclesSwitch from './vehicles/switch';
import EstimatesSwitch from './work-sheets/estimates/switch/estimates';
import JobsheetsSwitch from './work-sheets/switch';
const HaynesPro = () => {
  return (
    <>
      <DocumentTitle title="GDS > Haynes Pro" />
      <SMRDesktop type={HaynesProTypeEnum.LookupOnly} />
    </>
  );
};

const Routes = [
  <Route path="/jobsheets" component={JobsheetsSwitch} />,
  <Route path="/vehicles" component={VehiclesSwitch} />,
  <Route path="/estimates" component={EstimatesSwitch} />,
  <Route path="/haynes-pro" component={HaynesPro} />
];

export default Routes;
